import chakraTokenToVar from '@/utils/chakraTokenToVar'

const ACTIVITY_COLOR_LOW = 'yellow.muted'
const ACTIVITY_COLOR_HIGH = 'yellow.border'
const MAX_ACTIVITY_POINTS = 20

export default function getActivityLevelColor(numPoints: number): string {
  const activityRatio = Math.min(1, Math.max(0, numPoints / MAX_ACTIVITY_POINTS))
  const activityPercent = Math.round(activityRatio * 100)
  return `color-mix(in srgb, ${chakraTokenToVar(ACTIVITY_COLOR_HIGH)} ${activityPercent}%, ${chakraTokenToVar(ACTIVITY_COLOR_LOW)})`
}
